import { render, staticRenderFns } from "./KYCRequestsList.vue?vue&type=template&id=31846330&scoped=true"
import script from "./KYCRequestsList.vue?vue&type=script&lang=js"
export * from "./KYCRequestsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31846330",
  null
  
)

export default component.exports